import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { getResourceCategoryNameVariants } from '@mews-commander/legacy-entities/src/ducks/resourceCategories';
import { getResourceCategoryIdByResourceId } from '@mews-commander/legacy-entities/src/ducks/resourceCategoryAssignments';
import { WithServiceId } from '@mews-commander/types';
import { TooltippedSpan } from '@mews-commander/ui';
import { createPropsExtender } from '@mews/framework';
import { Identifiable } from '@mews/std';

interface ResourceCategoryNameProps {
    name?: string;
    shortName?: string;
    short?: boolean;
    tooltipped?: boolean;
}

const ResourceCategoryName = ({ name, shortName, short, tooltipped }: ResourceCategoryNameProps) => {
    const text = short ? shortName : name;
    return tooltipped ? <TooltippedSpan tooltip={name}>{text}</TooltippedSpan> : <>{text}</>;
};

const ResourceCategoryNameById = pipe(ResourceCategoryName, connect(getResourceCategoryNameVariants));

const ResourceCategoryNameByPartialId = ({
    id,
    serviceId,
    ...other
}: Partial<Identifiable> & WithServiceId & Pick<ResourceCategoryNameProps, 'short' | 'tooltipped'>) =>
    id ? <ResourceCategoryNameById id={id} serviceId={serviceId} {...other} /> : null;

export const ResourceCategoryNameByResource = pipe(
    ResourceCategoryNameByPartialId,
    connect(createPropsExtender('id', getResourceCategoryIdByResourceId))
);

export default ResourceCategoryNameById;
